import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';

type Props = {
  title: string;
  code: string;
  subtitle?: string | null;
  status: string;
  onPress: () => void;
  accessibilityLabel?: string;
};

export function MasterDataListItem({
  title,
  code,
  subtitle,
  status,
  onPress,
  accessibilityLabel,
}: Props) {
  const palette = useAppColors();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={
        accessibilityLabel || `${title}, code ${code}, status ${status}`
      }
      onPress={onPress}
      style={[
        styles.row,
        {
          backgroundColor: palette.surface,
          borderColor: palette.border,
        },
      ]}
    >
      <Text style={[styles.title, { color: palette.textPrimary }]}>{title}</Text>
      <Text style={[styles.meta, { color: palette.textSecondary }]}>
        Code: {code}
      </Text>
      {subtitle ? (
        <Text style={[styles.meta, { color: palette.textSecondary }]}>
          {subtitle}
        </Text>
      ) : null}
      <Text style={[styles.status, { color: palette.textPrimary }]}>
        Status: {status}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: {
    borderWidth: 1,
    borderRadius: 12,
    padding: spacing.lg,
    gap: spacing.xs,
  },
  title: { ...typography.body, fontWeight: '600' },
  meta: { ...typography.caption },
  status: { ...typography.caption },
});
